export const caseNiches = [
  'Кафе и рестораны',
  'Медицина',
  'Фитнес',
  'Образование',
  'E-commerce',
  'Бьюти',
  'Авто',
];

const platforms = [
  { name: 'ВКонтакте', icon: 'fa-brands fa-vk', color: '#0077FF' },
  { name: 'Яндекс Директ', icon: 'fa-brands fa-yandex', color: '#FC3F1D' },
  { name: 'Telegram', icon: 'fa-brands fa-telegram', color: '#2AABEE' },
  { name: 'Avito', icon: 'fa-solid fa-store', color: '#97CF26' },
];

const durations = ['2 месяца', '3 месяца', '4 месяца', '5 месяцев', '6 месяцев'];

const prefixes: Record<string, string[]> = {
  'Кафе и рестораны': ['Кафе', 'Ресторан', 'Кофейня', 'Бар'],
  Медицина: ['Клиника', 'Стоматология', 'Медцентр', 'Центр'],
  Фитнес: ['Фитнес-клуб', 'Студия', 'Центр', 'Клуб'],
  Образование: ['Школа', 'Центр', 'Академия', 'Курсы'],
  'E-commerce': ['Интернет-магазин', 'Магазин', 'Шоурум', 'Бренд'],
  Бьюти: ['Салон', 'Студия', 'Спа', 'Центр красоты'],
  Авто: ['Автосервис', 'СТО', 'Автоцентр', 'Мастерская'],
};

const companies: Record<string, string[]> = {
  'Кафе и рестораны': [
    'Roast', 'Веранда', 'Токио', 'Сырник', 'Брускетта', 'Паста-бар', 'Угли', 'Мята', 'Хмель', 'Гранат',
    'Кофемания', 'Пряности', 'Лаванда', 'Сальса', 'Базилик', 'Карамель', 'Олива', 'Томат', 'Черника', 'Апельсин',
    'Персик', 'Вишня', 'Инжир', 'Маслина', 'Прованс', 'Тоскана', 'Палермо', 'Неаполь', 'Венеция', 'Милан',
    'Хлеб', 'Ролл', 'Пицца',
  ],
  Медицина: [
    'Dental+', 'Smile', 'Семья', 'Доктор+', 'МедЛайф', 'ЛОР-Центр', 'Окулист', 'Дерма', 'Педиатр', 'Терапевт',
    'Хирург', 'Кардио', 'Невро', 'Гастро', 'Эндокрин', 'Уролог', 'Гинея', 'Премиум', 'Зубная Фея', 'Улыбка',
    'Ортодонт', 'Имплант', 'Здоровье', 'МедСтандарт', 'Лекарь', 'Эскулап', 'Гиппократ', 'Авиценна', 'Панацея', 'Здравница',
    'Вита', 'Биомед', 'Медлайн',
  ],
  Фитнес: [
    'Atlas', 'Формула', 'Титаны', 'Энергия', 'Импульс', 'Платина', 'Олимп', 'Зевс', 'Геркулес', 'Атлант',
    'Форсаж', 'Динамика', 'Тонус', 'Форма', 'Скульптор', 'Пауэр', 'Стронг', 'Арена', 'Баланс', 'Пилатес',
    'Йога', 'Кроссфит', 'Стретчинг', 'Зумба', 'Аэробика', 'ФитЛайф', 'Драйв', 'Ритм', 'Спортлайф', 'Профит',
    'Велнес', 'Старт', 'Победа',
  ],
  Образование: [
    'Lingua', 'Радуга', 'Умница', 'Знание', 'Полиглот', 'Эрудит', 'Интеллект', 'Академия', 'Сократ', 'Платон',
    'Архимед', 'Ньютон', 'Эйнштейн', 'Галилей', 'Дарвин', 'Ломоносов', 'Менделеев', 'Павлов', 'Циолковский', 'Гагарин',
    'Профи', 'Мастер', 'Вектор', 'Орбита', 'Горизонт', 'Прогресс', 'Успех', 'Лидер', 'Точка Роста', 'Формула',
    'IQ', 'Brain', 'SkillUp',
  ],
  'E-commerce': [
    'Volt', 'Лавка', 'Маркет', 'Шоп', 'Стиль', 'Тренд', 'Мода', 'Бутик', 'Хит', 'Топ',
    'Выбор', 'Класс', 'Люкс', 'Премиум', 'Комфорт', 'Дом', 'Квартал', 'Мир', 'Вселенная', 'Галактика',
    'Планета', 'Звезда', 'Комета', 'Орбита', 'Спутник', 'Ракета', 'Флагман', 'Лидер', 'Чемпион', 'Гигант',
    'Молния', 'Энергия', 'Свет',
  ],
  Бьюти: [
    'Lumière', 'Красота', 'Стиль', 'Гламур', 'Шарм', 'Фея', 'Нимфа', 'Венера', 'Афродита', 'Клеопатра',
    'Шик', 'Блеск', 'Сияние', 'Глянец', 'Элегант', 'Имидж', 'Образ', 'Макияж', 'Ноготок', 'Брови',
    'Ресницы', 'Волосы', 'Стрижка', 'Причёска', 'Салон', 'Студия', 'Спа', 'Массаж', 'Эстетика', 'Арт',
    'Гармония', 'Нежность', 'Соблазн',
  ],
  Авто: [
    'Гараж 55', 'АвтоМир', 'АвтоДом', 'АвтоСервис', 'АвтоЭксперт', 'АвтоСтоп', 'Драйв', 'Мотор', 'Турбо', 'Спид',
    'Форсаж', 'Шины', 'Колесо', 'Кузов', 'Тонировка', 'Детейлинг', 'Мойка', 'Шиномонтаж', 'Развал', 'Двигатель',
    'Трансмиссия', 'Подвеска', 'Тормоза', 'Электрика', 'Диагностика', 'СТО', 'Автоцентр', 'Автотех', 'Мастер', 'Профи',
    'Эксперт', 'Сервис', 'Автогараж',
  ],
};

const tasks: Record<string, string[]> = {
  'Кафе и рестораны': [
    'Новое заведение с нулевым сообществом — нужно быстро собрать локальную аудиторию и перевести её в заказы.',
    'Заполнить зал в будние дни и увеличить число броней на банкеты.',
    'Привлечь гостей на новое меню и повысить средний чек.',
    'Раскрутить доставку и увеличить число повторных заказов.',
    'Заполнить зал к открытию и создать очередь на брони.',
    'Увеличить число подписчиков и вовлечённость сообщества.',
    'Поднять продажи в выходные и привлечь семьи с детьми.',
  ],
  Медицина: [
    'Нужны целевые пациенты на конкретные услуги, а не случайные подписчики.',
    'Заполнить запись к врачам и снизить стоимость заявки.',
    'Привлечь пациентов на диагностику и комплексные программы.',
    'Увеличить поток первичных пациентов в новую клинику.',
    'Выстроить поток заявок на стоматологические услуги.',
    'Повысить узнаваемость клиники в городе.',
    'Заполнить запись на плановые процедуры в низкий сезон.',
  ],
  Фитнес: [
    'Заполнить группы и собрать очередь на пробные тренировки.',
    'Увеличить продажи абонементов и снизить стоимость лида.',
    'Привлечь клиентов в новый клуб к открытию.',
    'Заполнить группы на групповые программы.',
    'Увеличить удержание и число повторных продлений.',
    'Привлечь клиентов на персональные тренировки.',
    'Собрать заявки на летние программы и скидки.',
  ],
  Образование: [
    'Выстроить поток заявок на обучение и снизить стоимость лида.',
    'Привести родителей из нужного района и заполнить группы.',
    'Увеличить набор на курсы и онлайн-программы.',
    'Повысить узнаваемость школы и доверие.',
    'Заполнить летний лагерь и каникулярные программы.',
    'Привлечь взрослых на курсы и корпоративное обучение.',
    'Снизить стоимость заявки при сохранении объёма набора.',
  ],
  'E-commerce': [
    'Увеличить конверсию подписчиков в заказы и наладить поток продаж.',
    'Запустить продажи нового товара и собрать предзаказы.',
    'Снизить стоимость заявки и повысить средний чек.',
    'Вернуть брошенные корзины и увеличить повторные покупки.',
    'Повысить узнаваемость бренда и доверие к магазину.',
    'Увеличить трафик на распродажи и сезонные акции.',
    'Привлечь первую аудиторию к новому магазину.',
  ],
  Бьюти: [
    'Расписать записи на услуги и сделать сообщество живым.',
    'Привлечь клиентов на новые процедуры.',
    'Заполнить запись на ногтевой сервис и брови.',
    'Увеличить число повторных визитов и лояльность.',
    'Привлечь клиентов в новый салон к открытию.',
    'Повысить узнаваемость и доверие к мастерам.',
    'Заполнить запись в низкий сезон.',
  ],
  Авто: [
    'Увеличить число записей на ремонт и привлечь клиентов из района.',
    'Заполнить запись на шиномонтаж в сезон.',
    'Привлечь клиентов на детейлинг и комплексные услуги.',
    'Повысить узнаваемость сервиса и доверие.',
    'Увеличить поток на кузовной ремонт.',
    'Снизить стоимость заявки на техобслуживание.',
    'Привлечь клиентов на диагностику и плановое ТО.',
  ],
};

const solutions: Record<string, string[]> = {
  'Кафе и рестораны': [
    'Упаковали паблик, настроили таргет на жителей района и запустили серию акций с геометками.',
    'Сделали упор на бизнес-ланчи и банкетные предложения, настроили ретаргетинг по гостям.',
    'Запустили креативы с блюдами, добавили акции на дегустацию и собрали отзывы гостей.',
    'Настроили воронку с бонусами за повторный заказ и ретаргетинг по корзине.',
    'Таргет на район и оффер на первое посещение, прогрели аудиторию контентом.',
    'Запустили контент-план с конкурсами и отзывами, подключили таргет на интересы.',
    'Сделали акцент на семейные акции и детское меню, настроили таргет на родителей.',
  ],
  Медицина: [
    'Подключили контекст по спросу и связали его с сообществом для прогрева.',
    'Настроили таргет по гео и интересам, добавили отзывы пациентов.',
    'Запустили офферы на чекап и диагностику, прогрели аудиторию контентом.',
    'Локальный таргет и промо на первый приём, собрали отзывы.',
    'Таргет по спросу на имплантацию и лечение, добавили кейсы врачей.',
    'Комбинировали контекст и таргет в соцсетях, усилили отзывами.',
    'Акции на процедуры и ретаргетинг по базе клиентов.',
  ],
  Фитнес: [
    'Таргет на район с оффером на пробное занятие, добавили отзывы.',
    'Настроили воронку от пробного к абонементу, ретаргетинг по посетителям.',
    'Запустили предпродажи абонементов со скидкой, прогрели аудиторию.',
    'Таргет на женскую аудиторию, креативы с результатами участниц.',
    'Контент с результатами и челленджи, ретаргетинг по базе.',
    'Офферы на персональные занятия, таргет по интересам к фитнесу.',
    'Сезонные акции, таргет на район и аудиторию конкурентов.',
  ],
  Образование: [
    'Настроили воронку от подписки до пробного урока, прогрели контентом.',
    'Таргет на родителей по гео и акция на первое занятие.',
    'Воронка через вебинары и пробные уроки, ретаргетинг по участникам.',
    'Контент с преподавателями и результатами, отзывы учеников.',
    'Сезонный таргет на родителей, акция на раннее бронирование.',
    'Таргет по интересам, офферы на корпоративные программы.',
    'Оптимизировали креативы и аудитории, усилили ретаргетинг.',
  ],
  'E-commerce': [
    'Объединили Avito с сообществом, ретаргетинг по карточкам товаров.',
    'Прогревающая воронка с анонсами, таргет на целевую аудиторию.',
    'Оптимизировали креативы, добавили кросс-продажи в воронке.',
    'Ретаргетинг по корзине и базе клиентов с персональными офферами.',
    'Контент с отзывами и обзорами, таргет на интересы аудитории.',
    'Сезонные кампании, таргет по интересам и аудитории конкурентов.',
    'Упаковали сообщество, запустили таргет с офферами на стартовые покупки.',
  ],
  Бьюти: [
    'Таргет на женскую аудиторию района, креативы с работами мастеров.',
    'Акции на процедуры, контент с результатами и отзывами.',
    'Таргет по интересам, креативы с до/после и офферы на первое посещение.',
    'Программа лояльности и ретаргетинг по базе клиентов.',
    'Предзапись со скидкой, прогрели аудиторию района.',
    'Контент с мастерами и их работами, отзывы клиентов.',
    'Сезонные акции, ретаргетинг по базе и тёплой аудитории.',
  ],
  Авто: [
    'Локальный таргет на автовладельцев и промо на диагностику.',
    'Сезонный таргет, офферы на шиномонтаж и быстрые креативы.',
    'Контент с работами до/после, таргет на владельцев авто.',
    'Отзывы клиентов, таргет на район и интересы.',
    'Таргет по спросу на кузовные работы, кейсы с результатами.',
    'Оптимизировали аудитории и креативы, усилили ретаргетинг.',
    'Промо на диагностику, таргет на автовладельцев района.',
  ],
};

const resultLabels: Record<string, string[]> = {
  'Кафе и рестораны': ['заявок в месяц', 'бронирований', 'гостей в месяц', 'заказов'],
  Медицина: ['заявок на приём', 'записей', 'пациентов', 'обращений'],
  Фитнес: ['заявок на пробное', 'продаж абонементов', 'пробных занятий', 'заявок'],
  Образование: ['заявок на обучение', 'записей на урок', 'заявок', 'пробных уроков'],
  'E-commerce': ['заказов', 'заявок', 'продаж', 'конверсия в заказ'],
  Бьюти: ['записей', 'заявок', 'визитов', 'записей на услуги'],
  Авто: ['записей на ремонт', 'заявок', 'обращений', 'записей на ТО'],
};

const multipliers = ['×1,5', '×2', '×2,5', '×3'];

export const cases = caseNiches.flatMap((niche, n) =>
  companies[niche].map((name, i) => {
    const idx = n * 33 + i;
    const platform = platforms[idx % platforms.length];
    const followers = 5 + ((n * 7 + i) % 21);
    return {
      id: `case-${idx + 1}`,
      niche,
      company: `${prefixes[niche][i % prefixes[niche].length]} «${name}»`,
      platform: platform.name,
      platformIcon: platform.icon,
      platformColor: platform.color,
      duration: durations[idx % durations.length],
      task: tasks[niche][i % tasks[niche].length],
      solution: solutions[niche][i % solutions[niche].length],
      metrics: [
        { value: `${followers} тыс`, label: 'подписчиков' },
        { value: multipliers[idx % multipliers.length], label: resultLabels[niche][i % resultLabels[niche].length] },
      ],
    };
  })
);